<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" [attr.aria-label]="'layout.user.menu' | transloco">
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" [alt]="'layout.userAvatarAlt' | transloco" />
        }
        @if (!showAvatar || !user.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
        <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar,
                'bg-green-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-gray-400': user.status === 'not-visible',
            }"
        ></span>
    </span>
</button>

<mat-menu xPosition="before" #userActions="matMenu">
    <div class="px-4 py-3">
        <span class="flex flex-col leading-none">
            <span>{{ 'layout.user.signedInAs' | transloco }}</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </div>
    <mat-divider class="my-2"></mat-divider>
    <a mat-menu-item routerLink="/my-profile">
        <mat-icon svgIcon="heroicons_outline:user-circle"></mat-icon>
        <span>{{ 'myProfile.menuLabel' | transloco }}</span>
    </a>
    <button mat-menu-item (click)="signOut()">
        <mat-icon svgIcon="heroicons_outline:arrow-right-on-rectangle"></mat-icon>
        <span>{{ 'layout.user.signOut' | transloco }}</span>
    </button>
</mat-menu>
